import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=22519b7c&scoped=true&"
var script = {}
import style0 from "./Instruction.vue?vue&type=style&index=0&id=22519b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22519b7c",
  null
  
)

export default component.exports